export default "__VITE_ASSET__CUn3$Rtg__"